module.exports = __webpack_public_path__ + "static/media/hr_doc2.7475ff3d.JPG";